import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c58d58ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Transcripts" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-excel" }, null, -1))
const _hoisted_5 = { class: "mt-6" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_transcript_generation = _resolveComponent("transcript-generation")!
  const _component_transcript_filters = _resolveComponent("transcript-filters")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Транскрипты" }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/billing/transcripts/manual",
          class: "mr-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_the_button, {
              class: "primary small",
              hint: "Ручная генерация транскрипта"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.generation_state.is_opened)
      ? (_openBlock(), _createBlock(_component_transcript_generation, {
          key: 0,
          onCancel: _ctx.onCloseGenerateTranscript,
          onGenerated: _ctx.onTranscriptGenerated
        }, null, 8, ["onCancel", "onGenerated"]))
      : _createCommentVNode("", true),
    _createVNode(_component_transcript_filters, {
      class: "mt-6",
      loading: _ctx.state.is_loading,
      onSearch: _ctx.applyFilters,
      onResetted: _ctx.resetFilters
    }, null, 8, ["loading", "onSearch", "onResetted"]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.state.is_failed && !_ctx.state.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.state.is_loading,
            text: "При получении списка транскриптов произошла ошибка",
            "error-message": _ctx.state.failure.error_state.message,
            "error-url": _ctx.state.failure.error_state.url,
            "error-status": _ctx.state.failure.error_state.status,
            onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadTranscripts(_ctx.state.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
            key: 1,
            loading: _ctx.state.is_loading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_table, {
                loading: _ctx.state.is_loading,
                columns: _ctx.BillingTranscriptsColumns,
                rows: _ctx.state.list,
                "with-limit": "",
                "pagination-limit": _ctx.filters_state.limit,
                "pagination-total-items": _ctx.state.pagination.total_items,
                "pagination-current-page": _ctx.state.pagination.current_page,
                "pagination-total-pages": _ctx.state.pagination.total_pages,
                onChangePage: _ctx.loadTranscripts,
                onChangeLimit: _ctx.onLimitChange
              }, {
                td: _withCtx(({ column, row }) => [
                  (column.key === 'actNumber')
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        target: "_blank",
                        to: `/billing/transcripts/${row.id}`,
                        class: "Transcripts__link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (_ctx.isSignersOrApprovers(column.key))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: _normalizeClass(_ctx.getClass(column.key, row))
                        }, _toDisplayString(_ctx.getStats(column.key, row)), 3))
                      : (column.key === 'files')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(row[column.key].length), 1)
                          ], 64))
                        : (column.key === 'actFrom1CCreatedAt')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _createTextVNode(_toDisplayString(_ctx.formatDate(row[column.key])), 1)
                            ], 64))
                          : (column.key === 'company')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                _createTextVNode(_toDisplayString(row[column.key] ? row[column.key].short_name : '-'), 1)
                              ], 64))
                            : (column.key === 'finalAmount')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                  _createTextVNode(_toDisplayString(row[column.key] ? _ctx.numberWithSpaces(row[column.key]) : '-'), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                  _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                                ], 64))
                ]),
                actions: _withCtx(({ row }) => [
                  (
                                Boolean(row.company) &&
                                _ctx.havePermissions(['transcripts-update', 'all-root-permission']) &&
                                Boolean(row.actNumber)
                            )
                    ? (_openBlock(), _createBlock(_component_the_button, {
                        key: 0,
                        class: "yellow extra-small mr-3",
                        onClick: ($event: any) => (_ctx.onUpdateTranscript({ ...row })),
                        hint: "Редактировать"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_the_button, {
                    class: "red extra-small",
                    onClick: ($event: any) => (_ctx.deleteTranscript(row.id)),
                    hint: "Удалить"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
            ]),
            _: 1
          }, 8, ["loading"]))
    ])
  ]))
}